import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Settings, Plus, Pencil, Trash2 } from 'lucide-react';

export function AdminBar({ section, onAdd }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const canEdit = user?.is_admin || user?.is_editor || user?.role === 'admin' || user?.role === 'editor';
  if (!canEdit) return null;

  return (
    <div className="flex items-center gap-2 mb-4 p-3 bg-[#12100c]/5 border border-[#12100c]/10 rounded-xl" data-testid="admin-bar">
      <Settings className="w-4 h-4 text-[#12100c]" />
      <span className="text-xs font-medium text-[#12100c]">Modalità gestione</span>
      <div className="flex-1" />
      {onAdd && (
        <Button size="sm" onClick={onAdd} className="bg-[#12100c] hover:bg-[#5f7d52] text-white rounded-full h-7 px-3 text-[11px]" data-testid="admin-bar-add">
          <Plus className="w-3 h-3 mr-1" /> Aggiungi
        </Button>
      )}
      <Button size="sm" variant="outline" onClick={() => navigate(`/admin`)} className="rounded-full h-7 px-3 text-[11px] border-[#12100c]/30 text-[#12100c]" data-testid="admin-bar-panel">
        Pannello admin
      </Button>
    </div>
  );
}

export function EditButton({ onClick }) {
  const { user } = useAuth();
  const canEdit = user?.is_admin || user?.is_editor || user?.role === 'admin' || user?.role === 'editor';
  if (!canEdit) return null;

  return (
    <button onClick={onClick} className="p-1.5 rounded-lg hover:bg-[#12100c]/10 text-[#12100c]/40 hover:text-[#12100c] transition-colors" data-testid="inline-edit-btn" title="Modifica">
      <Pencil className="w-3.5 h-3.5" />
    </button>
  );
}

export function DeleteButton({ onClick }) {
  const { user } = useAuth();
  const canEdit = user?.is_admin || user?.is_editor || user?.role === 'admin' || user?.role === 'editor';
  if (!canEdit) return null;

  return (
    <button onClick={onClick} className="p-1.5 rounded-lg hover:bg-red-50 text-red-300 hover:text-red-500 transition-colors" data-testid="inline-delete-btn" title="Elimina">
      <Trash2 className="w-3.5 h-3.5" />
    </button>
  );
}
